import { render, staticRenderFns } from "./AppUploadButton.vue?vue&type=template&id=6fc0c505&scoped=true&"
import script from "./AppUploadButton.vue?vue&type=script&lang=js&"
export * from "./AppUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./AppUploadButton.vue?vue&type=style&index=0&id=6fc0c505&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc0c505",
  null
  
)

export default component.exports